var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gw-short-logo"},[_c('img',{attrs:{"src":require('@/../public/svg/gw-short-logo.svg'),"width":"30","height":"48","alt":"gw-short-logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }